import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Clock, Heart } from 'lucide-react';
export function TrustBadge() {
  return <section className="w-full bg-[#f5f0e8] py-16 px-4" data-id="element-334">
      <div className="max-w-3xl mx-auto" data-id="element-335">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-336">
          <p className="text-[#5b8a7a] font-medium text-sm tracking-widest uppercase mb-3" data-id="element-337">
            Compra Segura
          </p>
          <h2 className="font-serif text-2xl md:text-3xl text-[#0f172a] mb-4" data-id="element-338">
            Sin Riesgo. En Serio.
          </h2>
          <p className="text-[#475569] text-lg max-w-xl mx-auto leading-relaxed" data-id="element-339">
            Si abres el PDF y sientes que no es para ti, escríbenos y te
            devolvemos cada centavo. Sin preguntas, sin plazos raros.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-340">
          {[{
          icon: <Shield className="w-6 h-6 text-[#5b8a7a]" data-id="element-341" />,
          title: 'Garantía Total',
          desc: 'Si no te sirve, te devolvemos el 100%. Cero riesgo.'
        }, {
          icon: <Clock className="w-6 h-6 text-[#5b8a7a]" data-id="element-342" />,
          title: 'Descarga Inmediata',
          desc: 'Recibes todo al instante. Puedes usarlo esta misma noche.'
        }, {
          icon: <Heart className="w-6 h-6 text-[#5b8a7a]" data-id="element-343" />,
          title: '+850 Mamás Confían',
          desc: 'Cientos de madres ya usan estos guiones cada noche.'
        }].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-xl text-center border border-[#e2e8f0]" data-id="element-344">
              <div className="w-12 h-12 rounded-full bg-[#dcfce7] flex items-center justify-center mx-auto mb-4" data-id="element-345">
                {item.icon}
              </div>
              <h3 className="font-serif text-lg font-medium text-[#0f172a] mb-2" data-id="element-346">
                {item.title}
              </h3>
              <p className="text-[#64748b] text-sm leading-relaxed" data-id="element-347">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}